import { apiClient } from "../api/httpClient";

export const createSupportRequest = async (payload) => {
    // payload: { bond_type, name, request_body (json string), user_comment }
    return apiClient('/api/support-requests/create/', 'POST', payload);
};

export const listSupportRequests = async () => {
    return apiClient('/api/support-requests/list/', 'GET');
};

export const resumeSupportRequest = async (id) => {
    return apiClient(`/api/support-requests/${id}/resume/`, 'GET');
};

export const updateSupportRequest = async (id, payload) => {
    // payload: { internal_comment }
    return apiClient(`/api/support-requests/${id}/complete/`, 'PATCH', payload);
};

export const deleteSupportRequest = async (id) => {
    return apiClient(`/api/support-requests/${id}/delete/`, 'DELETE');
};
